import { render, staticRenderFns } from "./item-summary.vue?vue&type=template&id=15859d2c&scoped=true"
import script from "./item-summary.vue?vue&type=script&lang=js"
export * from "./item-summary.vue?vue&type=script&lang=js"
import style0 from "./item-summary.vue?vue&type=style&index=0&id=15859d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15859d2c",
  null
  
)

export default component.exports